import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadEmptyListingSuggestions } from '../../../common/actions/emptyListingSuggestions';
import { ListingSkeleton } from '../../../common/components/OfferCardHorizontal/components/OfferCardSkeleton';
import { prepareEmptyListingSuggestionOffer } from '../../../common/mappers/emptyListingSuggestions';
import { selectIsDesktopListingVisible } from '../../../common/selectors/desktopListing';
import { selectEmptyListingSuggestions } from '../../../common/selectors/emptyListingSuggestions';
import { EFetchStatus } from '../../../common/types/listingOffers';
import { TThunkDispatch } from '../../../common/types/redux';
import { EmptyListingSuggestionsLayout } from '../../components/EmptyListingSuggestionsLayout';
import { OfferCardDesktopContainer } from '../OfferCardDesktopContainer';

const SKELETONS_COUNT = 2;

export const EmptyListingSuggestionsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isSidebarVisible = useSelector(selectIsDesktopListingVisible);
  const { status, offers } = useSelector(selectEmptyListingSuggestions);

  // Единственный триггер загрузки рекомендаций: контейнер показан в empty-ветке листинга.
  // Покрывает все пути в пустую выдачу (пустая карта, пустой ответ листинга, открытие сайдбара).
  // Гейт по видимости обязателен: сайдбар скрывается через css, и empty-ветка с этим
  // контейнером остаётся смонтированной при закрытом сайдбаре.
  React.useEffect(() => {
    if (!isSidebarVisible) {
      return;
    }

    dispatch(loadEmptyListingSuggestions());
  }, [isSidebarVisible, dispatch]);

  const cardOffers = React.useMemo(() => offers.map(prepareEmptyListingSuggestionOffer), [offers]);

  const isLoading = status === EFetchStatus.LOADING;
  const hasOffers = cardOffers.length > 0;

  if (!isLoading && !hasOffers) {
    return null;
  }

  return (
    <EmptyListingSuggestionsLayout>
      {isLoading ? (
        <ListingSkeleton count={SKELETONS_COUNT} />
      ) : (
        cardOffers.map((offer, index) => (
          <OfferCardDesktopContainer
            key={offer.id}
            offer={offer}
            offerPosition={index + 1}
            offersLength={cardOffers.length}
            variant="recommendation"
          />
        ))
      )}
    </EmptyListingSuggestionsLayout>
  );
};
